import classsnames from 'classnames/bind';
import { Icon, Notification as NotificationGrabUI } from 'grab-ui';
import I18n from 'i18n-js';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isFunction from 'lodash/isFunction';
import _uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { clearNotificationAction } from 'actions/app-actions';
import {
  isAreaZoningHardBlock,
  isAreaZoningSoftBlock,
} from 'helper/error-codes';
import {
  ErrorCircleIcon,
  WarningTriangleIcon,
} from 'views/v2/new-booking-page/quote-panel/warning-triangle-icon';

import css from './notification.less';

const cx = classsnames.bind(css);

export const NOTIFICATION_TYPE = {
  CONFIRMED: 'CONFIRMED', // default
  WARNING: 'WARNING',
  INFO: 'INFO',
  CUSTOM: 'CUSTOM',
};

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { notifications, clearNotification } = this.props;

    if (_isEmpty(notifications)) return;

    notifications.forEach(noti => {
      const { type } = noti;

      if (!type || type === NOTIFICATION_TYPE.CONFIRMED) {
        const { id, message, description, duration, link } = noti;

        NotificationGrabUI.open({
          key: id || _uniqueId(),
          message: I18n.t(message, { defaultValue: message }),
          description: (
            <div>
              {this.getDescriptionToShow(description)} {link}
            </div>
          ),
          duration: duration || 5,
          icon: <Icon type="check-circle" className={css.icon} />,
          closeIcon: <Icon type="close" />,
          className: css.confirmedNotification,
        });
      }

      if (type === NOTIFICATION_TYPE.WARNING) {
        const { id, message, description, duration, errorCode } = noti;

        if (isAreaZoningHardBlock(errorCode)) {
          NotificationGrabUI.open({
            key: id || _uniqueId(),
            message: I18n.t(message, { defaultValue: message }),
            description: this.getDescriptionToShow(description),
            duration: duration || 10,
            icon: <ErrorCircleIcon className={css.customIcon} />,
            closeIcon: <Icon type="close" />,
            className: cx('confirmedNotification', 'evHardBlockNotification'),
          });
        } else {
          NotificationGrabUI.open({
            key: id || _uniqueId(),
            message: I18n.t(message, { defaultValue: message }),
            description: this.getDescriptionToShow(description),
            duration: duration || 10,
            icon: <Icon type="exclamation-circle" className={css.icon} />,
            closeIcon: <Icon type="close" />,
            className: cx('confirmedNotification', 'warningNotification'),
          });
        }
      }

      if (type === NOTIFICATION_TYPE.INFO) {
        const { id, message, description, duration, errorCode } = noti;

        if (isAreaZoningSoftBlock(errorCode)) {
          NotificationGrabUI.open({
            key: id || _uniqueId(),
            message: I18n.t(message, { defaultValue: message }),
            description: this.getDescriptionToShow(description),
            duration: duration || 10,
            icon: <WarningTriangleIcon className={css.customIcon} />,
            closeIcon: <Icon type="close" />,
            className: cx('confirmedNotification', 'evSoftBlockNotification'),
          });
        } else {
          NotificationGrabUI.open({
            key: id || _uniqueId(),
            message: I18n.t(message, { defaultValue: message }),
            description: this.getDescriptionToShow(description),
            duration: duration || 10,
            icon: <Icon type="info-circle" className={css.icon} />,
            closeIcon: <Icon type="close" />,
            className: cx('confirmedNotification', 'infoNotification'),
          });
        }
      }

      if (type === NOTIFICATION_TYPE.CUSTOM) {
        const { className, ...rest } = noti;
        Notification.open({
          duration: 5,
          className: cx('confirmedNotification', className),
          ...rest,
        });
      }
    });

    clearNotification(); // clear notification in redux
  }

  getDescriptionToShow = description => {
    if (!description) {
      return null;
    }

    if (_isFunction(description)) {
      const { history, dispatch } = this.props;
      return description(history, dispatch);
    }

    if (_isArray(description)) {
      return <div>{description.map(text => <div>{`- ${text}`}</div>)}</div>; // eslint-disable-line
    }

    return I18n.t(description, { defaultValue: description });
  };

  render() {
    return <div />;
  }
}

Notification.propTypes = {
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      message: PropTypes.string,
      description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
        PropTypes.shape({}),
      ]),
      custom: PropTypes.node,
      onClick: PropTypes.func,
      errorCode: PropTypes.number,
    }),
  ),
  clearNotification: PropTypes.func.isRequired,
  dispatch: PropTypes.func,
  history: PropTypes.shape({}).isRequired,
};

Notification.defaultProps = {
  notifications: [],
  dispatch: () => {},
};

const mapStateToProps = state => ({
  notifications: state.app.notifications,
});

const mapDispatchToProps = {
  clearNotification: clearNotificationAction,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Notification),
);
